import common from "./common";

let serviceReportMethods = {
    getModifiedReportsList(list = []) {
        let modified = [];
        
        list.forEach(report => {
            if(!report.createdAt){
                return
            }
            modified.push({
                ...report,
                report_date: report.createdAt?report.createdAt.slice(0, 10).split("-").reverse().join("-"):"",
                _id: report._id,
            })
        })

        return modified
    },
    modifyServiceForReports(list) {
        let newlist = [];
        list.forEach(item => {
            newlist.push({
                "client_name": "XXXXXXXXXXXX",
                "client_email": "XXXXXXXXXXXX",
                "client_address": "XXXXXXXXXXXX",
                "contact_person_name": "XXXXXXXXXXXX",
                "contact_person_phone": "XXXXXXXXXXXX",
                "contact_person_designation": "XXXXXXXXXXXX",
                "service_engineer_name": "XXXXXXXXXXXX",
                "service_engineer_email": "XXXXXXXXXXXX",
                "service_engineer_contact_number": "XXXXXXXXXXXX",
                // "date_of_service": "XXXXXXXXXXXX",
                ...item,
                "is_quotation_required":item.is_quotation_required?"YES":"NO",
                "date_of_service":common.formatDate(item.date_of_service)
            })
        })

        return newlist

    }
}

export default serviceReportMethods

